var ski_pole_length_calculator = function(height, style) {

  var coefficient = 0.7;

  if (style === "Recreational") {
    coefficient = 0.7;
  } else if (style === "Sporty") {
    coefficient = 0.68;
  } else if (style === "Freeride") {
    coefficient = 0.66;
  } else if (style === "Touring") {
    coefficient = 0.66;
  }

  var result = height * coefficient;
  return Math.round(result);
};

module.exports.calculate = ski_pole_length_calculator;
